<template>
  <div>
    <div style="font-size:15px;">
      <div style="display:flex;align-items:center;flex-direction:column;justify-content:center;color:#757575;">
        <h3 v-if="title">{{ title }}</h3>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'info',
    props: ['title'],
    components: {},
    data () {
      return {}
    },
    created () {},
    methods: {

    },
    computed: {

    },
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/views/infoView.vue